import {
  FETCH_QUALIFY_STATUS,
  QUALIFY_STATUS_ERROR,
  QUALIFY_STATUS_LOADING,
  QUALIFY_STATUS_SUCCESS,
} from '@/app/qualify/store/types';

import { http } from '@/api';
import { REFRESH_REQUEST } from '@/app/auth/store/types';

export const actions = {
  [FETCH_QUALIFY_STATUS]: ({ commit, dispatch }, userId) => new Promise((resolve, reject) => {
    commit(QUALIFY_STATUS_LOADING);
    http.get(`/qualify/apps/${userId}/analyze`)
      .then((resp) => {
        commit(QUALIFY_STATUS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(QUALIFY_STATUS_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(FETCH_QUALIFY_STATUS, userId);
            });
        } else {
          reject(err);
        }
      });
  }),
};
